import { render, staticRenderFns } from "./ChartingWorkspacePage.vue?vue&type=template&id=81babf0e&scoped=true&"
import script from "./ChartingWorkspacePage.vue?vue&type=script&lang=js&"
export * from "./ChartingWorkspacePage.vue?vue&type=script&lang=js&"
import style0 from "./ChartingWorkspacePage.vue?vue&type=style&index=0&id=81babf0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81babf0e",
  null
  
)

export default component.exports